import { render, staticRenderFns } from "./packageEpcPh.vue?vue&type=template&id=70fb7e0c&scoped=true"
import script from "./packageEpcPh.vue?vue&type=script&lang=js"
export * from "./packageEpcPh.vue?vue&type=script&lang=js"
import style0 from "./packageEpcPh.vue?vue&type=style&index=0&id=70fb7e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb7e0c",
  null
  
)

export default component.exports